import React, { useCallback, useEffect, useState } from "react";
import {
  Autocomplete,
  CircularProgress,
  TextField,
  debounce,
} from "@mui/material";

import { toast } from "react-toastify";
import { Avatar } from "@mui/material";
import Box from '@mui/material/Box';
import { MemberIcon } from "../../../constants/MemberIcon";
import { getUrl } from "../../../helpers/file_helper";

// props -> listCall ->api, label, apiParams -> basic params like filter, selectedItem
export function SearchDropDownListComponent({
  listCall,
  label,
  defaultValue,
  disabled,
  apiParams,
  searchEnabled,
  emitItem,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [mounted, setMounted] = useState(false);
  const [optionResult, setOptionResult] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedValue, setSelectedValue] = useState();
  const [options, setOptions] = useState([]);

  const getOptionsDelayed = useCallback(
    debounce((query, params, cb) => {
      setOptions([]);
      fetchOptions(query, params).then((response) => {
        cb(response);
      });
    }, 1200),
    []
  );
  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (mounted && isOpen) {
      setLoading(true);
      getOptionsDelayed(searchQuery, apiParams, (response) => {
        setOptionResult(response.data.data.data);
        const optionsList = response.data.data.data.map((opts) => {
          const name = `${opts?.firstName} ${opts?.lastName}`
          return {
            id: opts.id,
            label: opts?.name ? opts.name : name,
            key: `${opts.id}|${opts?.name ? opts.name : name}`,
          };
        });
        setOptions(optionsList);
        setLoading(false);
      });
    }
  }, [searchQuery, getOptionsDelayed, isOpen]);

  const fetchOptions = async (query, params) => {
    try {
      const queryParams = {
        ...params,
      };
      if (query && searchEnabled) {
        queryParams.search = query;
      }

      const response = await listCall(queryParams);
      return response;
    } catch (e) {
      setLoading(false);
      toast.error("Encountered problem with fetching records.");
    }
  };
  
  return (
    <>
    {/* <Box sx={{ display: 'flex', alignItems: 'flex-end'}} >
      <TextField id="input-with-sx" label="With sx" variant="standard" />
    </Box> */}
      <Box sx={{ display: 'flex', alignItems: 'flex-end'}}>
        {!defaultValue?.profilePicture &&
          <Avatar className="me-2" {...MemberIcon(selectedValue !== undefined ? selectedValue?.label : defaultValue?.label ?? null
          )}/>
        }
        {defaultValue?.profilePicture &&
          <img
            src={getUrl(defaultValue?.profilePicture)}
            alt=''
            className="rounded-circle header-profile-user me-2"
          />
        }
        <Autocomplete
          className="mt-2 w-100"
          size="small"
          open={isOpen}
          disabled={disabled ?? false}
          onOpen={() => {
            setIsOpen(true);
          }}
          onClose={() => {
            setIsOpen(false);
            setOptions([]);
            setOptionResult([]);
          }}
          value={
            selectedValue !== undefined ? selectedValue : defaultValue ?? null
          }
          options={options}
          isOptionEqualToValue={(option, value) => option?.id === value?.id}
          onChange={(event, newValue) => {
            setSelectedValue(newValue);
            const itemToSend =
              newValue !== null
                ? optionResult.find((_or) => _or.id === newValue.id)
                : undefined;
            emitItem(itemToSend);
          }}
          loading={loading}
          filterOptions={(opt) => opt}
          onInputChange={(event, newValue) => {
            setSearchQuery(newValue);
          }}
          renderOption={(props, option) => {
            return (
              <li {...props} key={option.id}>
                {option.label}
              </li>
            );
          }}
          renderInput={(params) => (
            <TextField
              key={params.id}
              {...params}
              placeholder={label}
              variant="standard"
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <React.Fragment>
                    {loading ? (
                      <CircularProgress color="inherit" size={20} />
                    ) : null}
                    {params.InputProps.endAdornment}
                  </React.Fragment>
                ),
              }}
            />
          )}
        />
      </Box>
    </>
  );
}
